import {Component, OnInit} from '@angular/core';
import {SettingService} from '../../shared/services/setting.service';
import {AlertService} from '../../shared/services/alert.service';

@Component({
    selector: 'app-referral-calculator',
    templateUrl: './referral-calculator.component.html',
    styleUrls: ['./referral-calculator.component.scss']
})
export class ReferralCalculatorComponent implements OnInit {
    submitting: any = false;
    referral: any = {
        max_reward_points: null,
        max_saving_amount: null,
        min_referrals: null,
        max_referrals: null,
        referrals_increment: null,
        min_months: null,
        max_months: null
    };
    referralBadgeTiers: any[] = [];

    constructor(private settingService: SettingService,
                private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.get();
    }

    get() {
        this.submitting = true;
        this.settingService.detail().subscribe(data => {
            this.referral['max_reward_points'] = data.referral_max_reward_points;
            this.referral['max_saving_amount'] = data.referral_max_saving_amount;
            this.referral['min_referrals'] = data.referral_min_referrals;
            this.referral['max_referrals'] = data.referral_max_referrals;
            this.referral['referrals_increment'] = data.referral_referrals_increment;
            this.referral['min_months'] = data.referral_min_months;
            this.referral['max_months'] = data.referral_max_months;
            this.referralBadgeTiers = data.referral_badge_tiers ? data.referral_badge_tiers : [];
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    save() {
        this.submitting = true;
        const payload = {
            'referral_max_reward_points': this.referral.max_reward_points,
            'referral_max_saving_amount': this.referral.max_saving_amount,
            'referral_min_referrals': this.referral.min_referrals,
            'referral_max_referrals': this.referral.max_referrals,
            'referral_referrals_increment': this.referral.referrals_increment,
            'referral_min_months': this.referral.min_months,
            'referral_max_months': this.referral.max_months,
            'referral_badge_tiers': this.referralBadgeTiers
        };
        this.settingService.update(payload).subscribe(data => {
            this.submitting = false;
            this.alertService.showSuccess({title: 'Success', message: 'Referral calculator settings updated successfully'});
        }, error => {
            this.submitting = false;
            this.alertService.showErrors('Failed to update referral calculator settings');
        });
    }
}
